angular.module('leanlaw').factory('clientsdata', [function () {
  return {
    clients: [],
    clientId: {},
    client: {},
    message: {},
    qbMessage: {},
    qbCustomers: [],
    qbCheck: {},
    messages: []
  };
}]);